import * as actionTypes from "./actionTypes";
import * as contactService from "./service";

const log = require("loglevel").getLogger("ContactActions");
log.setLevel("error");

export const loadContacts = (vendor,limit, offset, withTotal,selectedFilters, callback) => {
  return async (dispatch) => {
    log.debug("ContactActions -> loadContacts -> Enter");

    const result = await contactService.loadContacts(
      vendor,
      limit,
      offset,
      withTotal,
      selectedFilters
    );

    callback?.(result);
    await dispatch({
      type: actionTypes.CONTACTS_LOADED,
      data: result?.contacts ?? [],
      total: result?.total ?? 0,
      vendor,
    });
  };
};

export const loadContactByVendorAndId = (vendor, id, callback) => {
  return async (dispatch) => {
    log.debug("ContactActions -> loadContactByVendorAndId -> Enter");

    const contact = await contactService.loadContactByVendorAndId(vendor, id);

    callback?.(contact);
    
    await dispatch({
      type: actionTypes.CONTACT_LOADED,
      data: contact,
      vendor,
    });
  };
};

export const uploadContacts = (file, vendor, callback) => {
  return async (dispatch) => {
    log.debug("databaseBackupsActions -> uploadContacts -> Enter");
    const result = await contactService.uploadContacts(file, vendor);

    callback?.(result);
  };
};
